import { useEffect, useRef } from "react";
import AnimatedCursor from "react-animated-cursor";
export default function GamingCursor() {
  const cursorRef = useRef(null);

  useEffect(() => {
    const cursor = cursorRef.current;

    // Mouse move
    const handleMove = (e) => {
      const { clientX: x, clientY: y } = e;
      cursor.style.left = x + "px";
      cursor.style.top = y + "px";
      createTrail(x, y);
    };

    // Click effect
    const handleClick = () => {
      cursor.classList.add("click");
      setTimeout(() => cursor.classList.remove("click"), 300);
    };

    // Hover effect
    const handleHover = () => cursor.classList.add("hover");
    const handleLeave = () => cursor.classList.remove("hover");

    document.addEventListener("mousemove", handleMove);
    document.addEventListener("mousedown", handleClick);

    document.querySelectorAll("a, button, .game-btn, .nav-link").forEach((el) => {
      el.addEventListener("mouseenter", handleHover);
      el.addEventListener("mouseleave", handleLeave);
    });

    return () => {
      document.removeEventListener("mousemove", handleMove);
      document.removeEventListener("mousedown", handleClick);
    };
  }, []);

  // Create glowing trail
  function createTrail(x, y) {
    const trail = document.createElement("div");
    trail.className =
      "fixed w-[6px] h-[6px] rounded-full bg-[#6263ED]/80 pointer-events-none animate-[trail-fade_0.8s_ease-out_forwards] z-50";
    trail.style.left = x + "px";
    trail.style.top = y + "px";
    trail.style.transform = "translate(-50%, -50%)";
    document.body.appendChild(trail);
    setTimeout(() => trail.remove(), 800);
  }

  return (
    <>
      {/* Cursor */}

      {/* <AnimatedCursor
        innerSize={12}
        outerSize={35}
        color="237, 0, 158" // use your brand color (RGB format)
        outerAlpha={0.4}
        innerScale={0.7}
        outerScale={1.5}
        clickables={[
          'a',
          'button',
          '.link', // your custom clickable class
          'input[type="text"]',
          'input[type="email"]',
          'input[type="number"]',
          'input[type="submit"]',
          'input[type="image"]',
          'label[for]',
          'select',
          'textarea'
        ]}
      /> */}
      <div
        ref={cursorRef}
        className="fixed w-4 h-4 bg-[#ed009e] rounded-full 
        shadow-[0_0_20px_rgba(0,245,255,0.6),0_0_40px_rgba(255,0,255,0.4)] 
        pointer-events-none z-[10000]  transition-transform duration-300"
        style={{ transform: "translate(-50%, -50%)" }}
      >
        <span className="absolute inset-[-8px] rounded-full border-2 border-[#A7006F]/40 " />
      </div>

      {/* Tailwind keyframes */}
      <style>{`
        /* Hover color change */
        .hover {
          background: #ed009e !important;
          box-shadow: 0 0 20px rgba(255,107,53,0.8), 0 0 40px rgba(247,147,30,0.6) !important;
          transform: translate(-50%, -50%) scale(1.3) !important;
        }

        /* Click color change */
        .click {
          background: #af1d7e !important;
          box-shadow: 0 0 20px rgba(255,0,128,0.8), 0 0 40px rgba(128,0,255,0.6) !important;
          transform: translate(-50%, -50%) scale(1.3) !important;
        }

        /* Trail animation */
        @keyframes trail-fade {
          0% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
          100% { opacity: 0; transform: translate(-50%, -50%) scale(0.3); }
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
}
